import Header from "../components/Header";
import Navbar from "../components/Navbar";

export default function Main() {
  return (
    <div className="landing-page">
      <Navbar />
      <Header />
    </div>
  );
}
